export default {
  LoginFailure: '登录失败，请重试！',
  LoginSuccess: '登录成功！',
  UserPasswordError: '用户名或密码错误！',
  GeetestCaptchaError: '请等待极验验证完成！',
  ValidateCodeError: '滑动验证错误',
  UserNotExist: '用户不存在',
  UserNameOrPasswordNull: '用户/密码必须填写',
  IpBlackList: '很遗憾，访问IP已被列入系统黑名单',
  UserNameRemoved: '对不起，您的账号已被删除',
  UserNameStop: '用户已停用，请联系管理员',
  PassWordErrorMoreLock: '密码输入错误5次，帐户锁定10分钟',
  GoogleVerifyError: '谷歌验证码错误',
  VerificationCodeNull: '验证码必须填写',
  VerificationCodeErrorOrExpired: '验证码错误或已失效',
  VerificationCodeSendFrequently: '验证码错发送频率过高',
  GoogleBindError: '谷歌验证器绑定失败',
  VerificationCodeSendError: '邮箱验证码发送异常',
  SendEmailParamsNotNull: '邮箱验证码发送参数不能为空',
  UserNotLogin: '用户未登录',
  SendEmailError: '邮件信息发送异常',
  USER_NOT_AUTHORIZED: '用户没有权限',
  BdUserInfoInsertError: 'BD用户信息添加异常',
  UidExist: 'Uid已经存在，请勿重复添加',
  EmailExist: '该邮箱已经存在',
  EmailNotExist: '邮箱不存在',
  BdStatusJob: 'BD在职不允许删除',
  BDExistJunior: 'BD存在下级不允删除',
  GoogleVerifyRemoveError: '谷歌验证删除异常',
  DataExist: '数据已经存在',
  DataNotExist: '数据不存在',
  NotDirect: '不是直属关系',
  InvitationUpdateError: '邀请链路关系修改异常',
  AgentRoleIsExist: '返佣配置已存在',
  NoSelectSymbol: '请至少选择一个参与币种',
  LevelSymbolError: '下级返佣配置不允许比上级配置高',
  LevelSymbolMaxError: '返佣配置不允许小于0大于等于100',
  OnlyModifySelf: '只能编辑自己的创建的数据',
  OnlyDeleteSelf: '只能删除自己的创建的数据',
  CommissionUsed: '返佣策略被合伙人使用不允许删除',
  UserEmailNotExist: '用户未绑定邮箱,不可设置',
  UserIsPartner: '该用户已经是合伙人身份,请重新输入',
  RoleTypeNotSameWithPid: '返佣方式与上级不一致,请重新选择',
  BdOrPartnerOnly: '当前页面仅仅针对BD/合伙人角色开放',
  UserListExistBD: '该用户邀请链路中存在BD',
  PartnerExist: '用户已经是合伙人',
  RoleTypeNotSame: '返佣类型不一致',
  LevelSymbolTotalMaxError: '返佣配置百分比相加不能等于或大于100',
  LengthError: '长度不符合要求',
  NOT_INNER_DOMAIN: '管理员账号请使用内部域名登录访问',
  ExistPid: '该用户存在上级不允许设置成BD',
  LevelSymbolGapError: '下级返佣比例必须小于上级返佣比例',
};
